import * as Icon from '@/materials/icons/all'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { css } from 'styled-components/macro'
import { Outcome, Result, unPercent } from '../../../domain'

const Root = 'a'

interface Props extends React.ComponentPropsWithoutRef<typeof Root> {
  name: React.ReactNode
  outcome: Outcome
  finalResult: Result
}

function Tile(props: Props) {
  const { name, outcome, finalResult, ...rest } = props

  return (
    <Root css={[styles.root, styles.outcome[outcome]] as any} {...rest}>
      <div css={styles.name as any}>{name}</div>
      <div css={styles.result as any}>
        <FormattedMessage
          id="EZXbiQY"
          defaultMessage="{outcome, select, yea {{yeaResult, number, percent1} Ja} nay {{nayResult, number, percent1} Nein} other {WAT}}"
          values={{
            outcome,
            yeaResult: unPercent(finalResult.votes.yea.percent),
            nayResult: unPercent(finalResult.votes.nay.percent),
          }}
        />
      </div>
      <div css={styles.label as any}>
        <Icon.Checkmark24 />
        <FormattedMessage id="RSp8kPT" defaultMessage="Schlussresultat" />
      </div>
    </Root>
  )
}

export default Tile

const styles = {
  root: css`
    display: flex;
    flex-direction: column;

    cursor: pointer;

    color: inherit;
    text-decoration: none;

    & > * {
      transition: opacity 0.12s;
    }
    &:hover > * {
      opacity: 0.8;
    }
  `,

  outcome: {
    yea: css`
      --result-color: var(--blue-main);
    `,
    nay: css`
      --result-color: var(--red-main);
    `,
  },

  name: css`
    font-family: var(--font-sans-serif);
    font-weight: 700;
    font-size: 15px;
    line-height: 1.4;

    margin-bottom: 5px;

    overflow-wrap: anywhere;
  `,

  result: css`
    color: var(--result-color);

    font-family: var(--font-serif, var(--font-title));
    font-weight: 700;
    font-size: 1.25rem;
    line-height: 1.1;

    flex: 100% 0 1;

    @media only screen and (min-width: 1072px) {
      font-size: 1.5rem;
    }
  `,

  label: css`
    display: flex;
    align-items: center;

    font-family: var(--font-sans-serif);
    font-weight: 400;
    font-size: 15px;
    line-height: 1.4;

    margin-top: 20px;

    & > svg {
      margin: -3px 3px 0 -2px;
    }
  `,
}
